<template>
  <div class="empty-multimedia">
    <div class="empty-multimedia__container">
      <empty-icon class="empty-multimedia__icon" />
    </div>

    <div v-if="isHistory" class="empty-multimedia__text">
      <div v-if="campaign">
        <span>{{ `${empty} ${tab}` }}</span>
        <span>{{ fromCampaign }}</span>
        <span class="empty-multimedia__campaign">{{ campaign }}</span>
      </div>
      <span v-else>{{ `${empty} ${tab}` }}</span>
      <div>{{ checkConfig }}</div>
    </div>
    <div v-else class="empty-multimedia__text">
      <span>{{ `${empty} ${tab}` }}</span>
      <div>{{ checkConfig }}</div>
    </div>
  </div>
</template>
<script>
import EmptyIcon from '@/assets/icons/database-remove.svg';

export default {
  components: {
    EmptyIcon,
  },
  props: {
    tab: {
      type: String,
    },
    campaign: {
      type: String,
    },
  },
  computed: {
    empty() {
      return this.$t('multimedia.no-results');
    },
    fromCampaign() {
      return this.$t('multimedia.from-campaign', { campaign: this.campaign });
    },
    checkConfig() {
      return this.$t('multimedia.check-config');
    },

  },
};
</script>

<style lang="scss" scoped>
@import "~styles/components/chat-multimedia-empty.scss";
</style>
